import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import { Box, Container, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Parse from "../../API/ParseServer";
import Footer from "../../Components/Layout/Footer";
import ChromaGrid from "../../Components/UI/ArtistChromaGrid";
const Artists = () => {
  const [artists, setArtists] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [artistItems, setArtisItems] = useState<any[]>([]);

  useEffect(() => {
    const fetchArtists = async () => {
      const query = new Parse.Query("Artist");
      try {
        const results = await query.find();
        setArtists(results);
        setArtisItems(
          results.map((artist) => {
            return {
              image: artist.get("thumbnail").url(),
              title: artist.get("name"),
              subtitle: "",
              handle: "",
              borderColor: "#3B82F6",
              gradient: "linear-gradient(145deg, #3B82F6, #000)",
              url: `/artist/${artist.get("name")}`,
            };
          }),
        );
        console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArtists();
  }, []);

  return (
    <Fragment>
      <Box sx={{ backgroundColor: "#f5f5f5", py: 4 }}>
        <Container>
          <Typography component="h2" variant="h4">
            Artists
          </Typography>
          <Typography sx={{ marginTop: 4 }}>
            Discover talented artists from around the world and browse thousands
            of unique artworks. Explore hundreds of emerging and established
            contemporary artists, giving them a way to reach collectors and
            first-time art buyers alike. View their latest artworks, learn more
            about their backgrounds.
          </Typography>
        </Container>
      </Box>
      <Container>
        <Grid
          container
          sx={{ display: "flex", mb: 4, gap: { md: "2.5%", sm: "1%" } }}
        >
          {
            artists && (
              <ChromaGrid
                items={artistItems}
                radius={300}
                damping={0.45}
                fadeOut={0.6}
                ease="power3.out"
              />
            )
            // artists.map((artist: any) => {
            //   const name = artist.get("name");
            //   const picture = artist.get("thumbnail");
            //   const pictureUrl = picture ? picture._url : "";
            //   return (

            //     <Link to={`/artist/${name}`} key={name}>
            //       <Grid xs={12} sm={5.9} md={3.8} sx={{ mt: 4 }} item>
            //         {pictureUrl ? (
            //           <img
            //             src={pictureUrl}
            //             alt={name}
            //             style={{
            //               backgroundColor: "gray",
            //               width: "100%",
            //               aspectRatio: "1",
            //             }}
            //           />
            //         ) : (
            //           <Box
            //             sx={{
            //               width: "100%",
            //               aspectRatio: "1",
            //               backgroundColor: "gray",
            //             }}
            //           ></Box>
            //         )}

            //         <Typography
            //           variant="h6"
            //           sx={{ textAlign: "center", color: "#555" }}
            //           component="h1"
            //         >
            //           {name}
            //         </Typography>
            //       </Grid>
            //     </Link>
            //   );
            // })
          }
        </Grid>
      </Container>
    </Fragment>
  );
};

export default Artists;
